export default __webpack_public_path__ + "static/media/CBS-Word-Icon.331143b6.svg";